import { InventoryPrice, CentreServices } from './centre-service.model';
import { PaymentMethod, PaymentCard } from './payment.model';
import { SpaceType } from 'src/app/shared/constants/spaceTypes.constant';
import { DiscountType } from 'src/app/services/time-slot-discounts/time-slot-discounts.service';

export interface ReservationData {
  availableServices: CentreServices;
  expirationTimeUtc: string;
  id: string;
  slotId: string;
  inventoryDiscountPercent: number;
  inventoryLockId: string;
  inventoryPrice: InventoryPrice;
  isAlreadyReserved: boolean;
  isFreeVisit?: boolean;
  isPrePaidVisit?: boolean;
  paymentCards: Array<PaymentCard>;
  paymentMethods: Array<PaymentMethod>;
  validationStatus: ReservationValidationStatus;
}

export interface ReservationRequestData {
  date: string;
  timeFrom: string;
  timeUntil: string;
  numberOfPeople: number;
  spaceType: SpaceType;
  inventoryId: string;
  configurationId: string;
  accountId?: string;
  contactId?: string;
  timeSlotType?: DiscountType;
}

export enum ReservationValidationStatus {
  Succeeded = 'succeeded',
  InventoryAlreadyReserved = 'inventoryAlreadyReserved',
  InventoryReservationExpired = 'inventoryReservationExpired',
  InventoryReservationNotPossible = 'inventoryReservationNotPossible',
  Unexpected = 'unexpected'
}
